import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { injectIntl } from "react-intl";
import messages from "../../utils/commonwords";
import { signinUser } from "../../store/auth/actions";
import { SignInForm, AuthContainer } from "../../components";

class SignIn extends Component {
  render() {
    const {
      intl,
      siteLanguage,
      signingIn,
      signinUser,
      isAuthenticated
    } = this.props;

    if (isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: `/${siteLanguage || "en"}/`
          }}
        />
      );
    } else {
      return (
        <AuthContainer>
          <SignInForm
            intl={intl}
            messages={messages}
            siteLanguage={siteLanguage}
            signingIn={signingIn}
            signinUser={signinUser}
          />
        </AuthContainer>
      );
    }
  }
}

const mapStateToProps = state => ({
  siteLanguage: state.intl.siteLanguage,
  signingIn: state.auth.signingIn,
  isAuthenticated: state.user.isAuthenticated
});

const mapDispatchToProps = dispatch => ({
  signinUser: (intl, siteLanguage, { email, password }) => {
    dispatch(signinUser(intl, siteLanguage, { email, password }));
  }
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SignIn)
);
